import React, { useState } from "react";
import "./newsletter.css";
import { Grid, TextField, Button, Snackbar, Typography, Container, Box, LinearProgress } from "@mui/material";
import axios from "axios";
import HeadingContainer from "../heading-container/HeadingContainer";
import FloatingDecor from "../FloatingDecor/FloatingDecor";

const Newsletter = () => {
  const [config, setConfig] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    phoneError: false,
  });

  const [visible, setVisible] = useState(false);
  const [linearLoading, setLinearLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLinearLoading(true);
    if (config.phone.length !== 10) {
      setConfig({ ...config, phoneError: true });
      setLinearLoading(false);
      return;
    }
    setConfig({ ...config, phoneError: false });

    const backendUrl = process.env.REACT_APP_BACKEND_BASE_URI || "http://localhost:4000";
    axios
      .post(`${backendUrl}/users/api/addUser`, config, {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_API_PASSWORD}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setVisible(true);
        setLinearLoading(false);
        setConfig({ name: "", email: "", phone: "", message: "" });
      })
      .catch((err) => {
        setLinearLoading(false);
        console.error(err);
      });
  };

  const handleClose = () => {
    setVisible(false);
  };

  return (
    <>
      <HeadingContainer title="Contact Us" />
      {linearLoading && <LinearProgress color="success" sx={{ zIndex: 99999, position: 'relative' }} />}
      
      <div className="newsletter" id="contact">
        <FloatingDecor />
        <Container maxWidth="lg" className="formContainer">
          <Box className="contact-card">
            <Grid container spacing={4}>
              
              {/* Left Side: Contact Information Panel */}
              <Grid item xs={12} md={5}>
                <div className="contact-info-panel">
                  <Typography variant="h4" sx={{ fontWeight: 800, mb: 2, fontFamily: 'var(--font-heading)', color: 'white' }}>
                    Get In Touch! 👋
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 4, opacity: 0.95, color: 'white' }}>
                    We'd love to hear from you. Whether you have a question about admissions, programs, or anything else, our team is ready to answer all your questions.
                  </Typography>

                  <div className="info-item">
                    <div className="info-icon"><i className="ri-map-pin-line"></i></div>
                    <div>
                      <Typography variant="subtitle2" sx={{ opacity: 0.8, color: 'white' }}>Visit Us</Typography>
                      <Typography variant="body1" sx={{ fontWeight: 600, color: 'white' }}>Roshan Nagar-B Kanakpura, Sirsi Road Near Balaji Hospital, Jaipur (Raj) 302034</Typography>
                    </div>
                  </div>

                  <div className="info-item">
                    <div className="info-icon"><i className="ri-phone-line"></i></div>
                    <div>
                      <Typography variant="subtitle2" sx={{ opacity: 0.8, color: 'white' }}>Call Us</Typography>
                      <Typography variant="body1" sx={{ fontWeight: 600, color: 'white' }}>+91 98870 28003 <br/> +91 82332 77896</Typography>
                    </div>
                  </div>

                  <div className="info-item">
                    <div className="info-icon"><i className="ri-mail-send-line"></i></div>
                    <div>
                      <Typography variant="subtitle2" sx={{ opacity: 0.8, color: 'white' }}>Email Us</Typography>
                      <Typography variant="body1" sx={{ fontWeight: 600, color: 'white' }}>whitewings.jaipur@gmail.com</Typography>
                    </div>
                  </div>
                </div>
              </Grid>

              {/* Right Side: Contact Form */}
              <Grid item xs={12} md={7} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', p: { xs: 2, md: 4 } }}>
                <Typography variant="h3" sx={{ fontWeight: 800, fontFamily: 'var(--font-heading)', mb: 1, color: 'var(--text-main)' }}>
                  Send a <span className="text-gradient-primary">Message</span>
                </Typography>
                <Typography variant="subtitle1" sx={{ color: 'var(--text-muted)', mb: 5, fontSize: '1.1rem' }}>
                  Fill out the form below and we will get back to you as soon as possible!
                </Typography>

                <form onSubmit={handleSubmit}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Your Name"
                        variant="outlined"
                        fullWidth
                        value={config.name}
                        onChange={(e) => setConfig({ ...config, name: e.target.value })}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Your Email"
                        type="email"
                        variant="outlined"
                        fullWidth
                        value={config.email}
                        onChange={(e) => setConfig({ ...config, email: e.target.value })}
                        required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label="Phone Number"
                        type="number"
                        error={config.phoneError}
                        helperText={config.phoneError ? "Phone number must be exactly 10 digits" : ""}
                        variant="outlined"
                        fullWidth
                        value={config.phone}
                        onChange={(e) => setConfig({ ...config, phone: e.target.value })}
                        required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label="How can we help you?"
                        variant="outlined"
                        multiline
                        rows={4}
                        fullWidth
                        value={config.message}
                        onChange={(e) => setConfig({ ...config, message: e.target.value })}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} className="submitButton">
                      <Button variant="contained" type="submit" size="large">
                        Send Message 🚀
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </Grid>

            </Grid>
          </Box>
        </Container>

        <Snackbar
          sx={{ '& .MuiSnackbarContent-root': { backgroundColor: '#00a859', color: '#fff', fontSize: '1.1rem', fontWeight: 600 } }}
          open={visible}
          autoHideDuration={4000}
          onClose={handleClose}
          message="✨ Thank you! Your message has been sent successfully."
        />
      </div>
    </>
  );
};

export default Newsletter;
